import TextContent from "./TextContent";
import TextInput from "./TextInput";

function TextComponent({
  contentId,
  mandatory,
  sx,
  value,
  onChange,
  isEditing = false,
  choiseComponent = false,
  quadrantData = {},
  ...props
}) {
  const { confidential } = quadrantData;

  return choiseComponent ? (
    <p
      dangerouslySetInnerHTML={{
        __html: value,
      }}
    />
  ) : !isEditing ? (
    <TextContent
      sx={sx}
      htmlText={value}
      contentId={quadrantData?.chapterContentId}
      mandatory={mandatory}
      isConfidential={confidential === "S"}
    />
  ) : (
    <TextInput sx={sx} value={value} onChange={onChange} />
  );
}

export default TextComponent;
